

export function Resizer({
  axis,
  dir = 1,
  size,
  setSize,
}: {
  axis: 'x' | 'y';
  dir?: 1 | -1;
  size: number;
  setSize: (newSize: number) => void;
}): JSX.Element {
  const style = axis === 'x' 
    ? (dir === 1 ? { right: -5 } : { left: -5 }) 
    : (dir === 1 ? { bottom: -5 } : { top: -5 });

  return (
    <div
      className={`resizer resizer-${axis}`}
      style={style}
      onPointerDown={(e) => {
        const el = e.currentTarget;
        el.setPointerCapture(e.pointerId);
        const start = axis === 'x' ? e.clientX : e.clientY;
        const startSize = size;
        
        const onMove = (ev: PointerEvent) => {
          const current = axis === 'x' ? ev.clientX : ev.clientY;
          const delta = (current - start) * dir;
          setSize(startSize + delta);
        };
        
        const onUp = (ev: PointerEvent) => {
          el.removeEventListener('pointermove', onMove as any);
          el.removeEventListener('pointerup', onUp as any);
          el.releasePointerCapture(ev.pointerId);
        };
        
        el.addEventListener('pointermove', onMove as any);
        el.addEventListener('pointerup', onUp as any);
      }}
    />
  );
}
